const getters = {
  assigned_products: (state) => state.assigned_products,
}

export default getters
